
export interface AttendanceReportRecord {
  employeeId: number;
  employee_Code: string;
  employeeName: string;
  present: number;
  absent: number;
  halfDay: number;
  late: number;
  earlyOut: number;
  totalWorkTime:number;
  weekOff:number;
  punchMissing: number
}

export interface AttendanceDayDetail {
  date: string;
  checkIn: string | null;
  checkOut: string | null;
  status: number;
}

export interface AttendanceReports {
  totalCount: number;
  records: AttendanceReportRecord[];
}

export interface Props {
  reportData: AttendanceReports;
  dateRange: { from: Date; to: Date };
  setDateRange: (range: { from: Date; to: Date }) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  lazyParams: {
    first: number;
    rows: number;
    page: number;
    sortField: string;
    sortOrder: number;
  };
  setLazyParams: React.Dispatch<React.SetStateAction<any>>;
  totalCount: number;
  pageCount: number;
  handlePageClick: ({ selected }: { selected: number }) => void;
  loading: boolean;
  setRowsPerPage: (rows: number) => void;
  setSelectedItems: React.Dispatch<React.SetStateAction<Record<string, number[]>>>;
}

export const getStatusName = (status: number) => {
  switch (status) {
    case 1: return 'Present';
    case 0: return 'Absent';
    case 2: return 'Half Day';
    case 3: return 'Late';
    case 4: return 'Early Out';
    case 5: return 'Punch In Missing';
    case 6: return 'Punch Out Missing';
    case 7: return 'Week Off';
    case 8: return 'Holiday';
    default: return '—';
  }
};

export const getStatusClass = (status: number) => {
  switch (status) {
    case 1: return 'status_badge green';
    case 0: return 'status_badge red';
    case 2: return 'status_badge orange';
    case 3: return 'status_badge yellow';
    case 4: return 'status_badge purple';
    case 5: return 'status_badge blue';
    case 6: return 'status_badge pink';
    case 7: return 'status_badge cyan';
    case 8: return 'status_badge green';
    default: return 'status_badge gray';
  }
};

export const sortOptions = [
  'Name (A–Z)',
  'Name (Z–A)',
  'Present (High to Low)',
  'Present (Low to High)',
  'Absent (High to Low)',
  'Absent (Low to High)',
];

export const sortMapping: Record<string, { field: keyof AttendanceReportRecord; order: 1 | -1 }> = {
  'Name (A–Z)': { field: 'employeeName', order: 1 },
  'Name (Z–A)': { field: 'employeeName', order: -1 },
  'Present (High to Low)': { field: 'present', order: -1 },
  'Present (Low to High)': { field: 'present', order: 1 },
  'Absent (High to Low)': { field: 'absent', order: -1 },
  'Absent (Low to High)': { field: 'absent', order: 1 },
};